import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";
import { IconButton, useMediaQuery } from "@mui/material";
import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/aveti.png";
import { DarkModeContext } from "../../contexts/darkModeContext";
import useAuth from "../../contexts/UserContext.tsx";
import "./sidebar.scss";

const Sidebar = () => {
  useContext(DarkModeContext);
  const { logout, user } = useAuth();
  const media = useMediaQuery("(max-width: 768px)");
  const [collapsed, setCollapsed] = useState(media);
  return (
    <div
      className={
        collapsed
          ? "sidebar max-w-xs min-w-fit dark:bg-grey-50 collapsed"
          : "sidebar max-w-xs min-w-fit dark:bg-grey-50"
      }
    >
      <div className="top">
        <img src={logo} alt="logo" className="w-24 py-2 flex mx-auto" />
        {media ? (
          <div className="menuIcon">
            {
              <IconButton
                fontSize="small"
                onClick={() => setCollapsed((prev) => !prev)}
              >
                {collapsed ? <MenuIcon /> : <ArrowBackIosIcon />}
              </IconButton>
            }
          </div>
        ) : null}
      </div>
      <hr />
      <div className="center">
        <div className="menuGroup">
          <p className="title">Home</p>
          <ul>
            <li>
              <NavLink
                to="/"
                style={{ textDecoration: "none" }}
                className="w-full"
              >
                <DashboardIcon className="icon" />
                <span>Smart Class</span>
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="menuGroup">
          <p className="title">Schools</p>
          <ul>
            <li>
              <NavLink
                className="w-full"
                to="/district"
                style={{ textDecoration: "none" }}
              >
                <PlaceOutlinedIcon className="icon" />
                <span>Districts</span>
              </NavLink>
            </li>
            {/* <li>
        <NavLink to="/blocks" style={{ textDecoration: "none" }}>
            <DomainOutlinedIcon className="icon" />
            <span>Blocks</span>
        </NavLink>
        </li> */}
            <li>
              <NavLink
                className="w-full"
                to="/school"
                style={{ textDecoration: "none" }}
              >
                <SchoolOutlined className="icon" />
                <span>Schools</span>
              </NavLink>
            </li>
            {/* <li>
        <NavLink to="/teachers" style={{ textDecoration: "none" }}>
        <CastForEducationOutlinedIcon className="icon" />
        <span>Teachers</span>
   </NavLink>
        </li> */}
          </ul>
        </div>
        <div className="menuGroup">
          <p className="title">Learning</p>
          <ul>
            {/* <li>
            <NavLink to="/homelearning">
            <CameraOutdoorOutlinedIcon className="icon"/>
              <span>Home Learning</span>
            </NavLink>
          </li> */}
            <li>
              <NavLink
                className="w-full"
                to="/student"
                style={{ textDecoration: "none" }}
              >
                <LocalLibraryIcon className="icon" />
                <span>Student</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className="w-full"
                to="/teacher"
                style={{ textDecoration: "none" }}
              >
                <ContactEmergencyIcon className="icon" />
                <span>Teacher</span>
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="menuGroup">
          <p className="title">Tools</p>
          <ul>
            {/* <li>
            <NavLink to="#">
            <InsertChartIcon className="icon" />
             <span>Stats</span>
          </NavLink>
          </li>
          <li>
            <NavLink to="/syncStatus">
            <CloudSyncIcon className="icon" />
             <span>Sync Status</span>
          </NavLink>
          </li>
          <li>
            <NavLink to="#">
            <NotificationsNoneIcon className="icon" />
            <span>Notifications</span>
            </NavLink>
          </li> */}
            <li>
              <NavLink
                className="w-full"
                to="/serverstatus"
                style={{ textDecoration: "none" }}
              >
                <DnsOutlinedIcon className="icon" />
                <span>Server Status</span>
              </NavLink>
            </li>
          </ul>
        </div>
        {/* <div className="menuGroup">
        <p className="title">Serivce</p>
        <ul>
            <li>
                <NavLink to="#">
                <PsychologyOutlinedIcon className="icon" />
                <span>Logs</span>
                </NavLink>
            </li>
            <li>
                <NavLink to="#">
                <SettingsApplicationsIcon className="icon" />
          <span>Settings</span>
                </NavLink>
            </li>
            <li>
                <NavLink to="#">
                </NavLink>
            </li>
        </ul>
      </div> */}
        <div className="menuGroup">
          <p className="title">Report</p>
          <ul>
            <li>
              <NavLink
                className="w-full"
                to="/monthlyreport"
                style={{ textDecoration: "none" }}
              >
                <TimelineIcon className="icon" />
                <span>Monthly Report</span>
              </NavLink>
            </li>
            {/* <li>
            <NavLink to="#">
              <AssessmentIcon className="icon" />
              <span>Quarterly Report</span>
            </NavLink>
          </li> */}
          </ul>
          {/* <ul>
            <li>
              <NavLink
                className="w-full"
                to="/topstudents"
                style={{ textDecoration: "none" }}
              >
                <Equalizer className="icon" />
                <span>Top Students</span>
              </NavLink>
            </li>
          </ul> */}
        </div>
        {user.user_type === "admin" && (
          <div className="menuGroup">
            <p className="title">Admin</p>
            <ul>
              <li>
                <NavLink
                  className="w-full"
                  to="/dashboardUsers"
                  style={{ textDecoration: "none" }}
                >
                  <ManageAccountsIcon className="icon" />
                  <span>Dashboard users</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="w-full"
                  to="/mathlabUsers"
                  style={{ textDecoration: "none" }}
                >
                  <PersonIcon className="icon" />
                  <span>Mathlab users</span>
                </NavLink>
              </li>
            </ul>
          </div>
        )}
        <div className="menuGroup">
          <p className="title">User</p>
          <ul>
            {/* <li>
                <NavLink to="#">
                    <AccountCircleOutlinedIcon className="icon" />
                    <span>Profile</span>
                </NavLink>
            </li> */}
            <li>
              <button onClick={logout}>
                <ExitToAppIcon className="icon" />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </div>
        {/* <div className="bottom">
      <div
        className="colorOption"
        onClick={() => dispatch({ type: "LIGHT" })}
      ></div>
      <div
        className="colorOption"
        onClick={() => dispatch({ type: "DARK" })}
      ></div>
    </div> */}
      </div>
    </div>
  );
};

export default Sidebar;
